import * as dayjs from 'dayjs';
import { FarmerGroupPayload } from 'types/request';
import { FarmerGroupV2 } from 'types/response';

export type TFarmerGroupForm = Omit<
  FarmerGroupPayload,
  | 'firstEstimatedStartDate'
  | 'secondEstimatedStartDate'
  | 'thirdEstimatedStartDate'
> & {
  firstEstimatedStartDate: dayjs.Dayjs;
  secondEstimatedStartDate: dayjs.Dayjs;
  thirdEstimatedStartDate?: dayjs.Dayjs;
};

export const convertFarmerGroupToForm: (
  data?: FarmerGroupV2,
) => Partial<TFarmerGroupForm> = (data) => ({
  country: data?.address?.country,
  name: data?.name,
  address: data?.address,
  leaderId: data?.groupLeader?.id,
  paddyBuyerId: data?.paddyBuyer?.id,
  juniorAgronomistEmail: data?.rizeusersByFieldCoordinator?.email,
  almCoordinatorEmail: data?.almCoordinator?.email,
  firstEstimatedStartDate: convertEstimateDate(data?.firstEstimatedStartDate),
  secondEstimatedStartDate: convertEstimateDate(data?.secondEstimatedStartDate),
  thirdEstimatedStartDate: convertEstimateDate(data?.thirdEstimatedStartDate),
});

const convertEstimateDate = (str?: string) => {
  if (!str) return;
  const day = Number(str.split(' ')?.[0]);
  const month = Number(str.split(' ')?.[1]);
  return dayjs()
    .set('date', day)
    .set('month', month - 1);
};
